import React from "react";
import "./DateDisplay.css";

interface DateDisplayProps {
  hijriDate: string;
  gregorianDate: string;
  gregorianFormat?: "long" | "short";
  layout?: "stacked" | "inline"; // New prop for layout mode
  gregorianStyle?: React.CSSProperties;
  hijriStyle?: React.CSSProperties;
  gregorianAlignment?: "left" | "center" | "right";
  hijriAlignment?: "left" | "center" | "right";
}

const DateDisplay: React.FC<DateDisplayProps> = ({
  hijriDate,
  gregorianDate,
  gregorianFormat = "long",
  layout = "stacked", // Default to stacked for portrait
  gregorianStyle,
  hijriStyle,
  gregorianAlignment = "center",
  hijriAlignment = "center",
}) => {
  // Fallback to current date if gregorianDate is empty
  const ensureGregorianDate = () => {
    if (gregorianDate) return gregorianDate;

    // Format today's date as fallback
    const today = new Date();
    const options: Intl.DateTimeFormatOptions = {
      weekday: gregorianFormat,
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    return today.toLocaleDateString("en-US", options);
  };

  return (
    <div className={`date-display date-display-${layout}`}>
      <div className="combined-date">
        <span
          className={`gregorian-date date-segment date-align-${gregorianAlignment}`}
          style={{ ...gregorianStyle, textAlign: gregorianAlignment }}
        >
          {ensureGregorianDate()}
        </span>
        <span className="date-separator"> | </span>
        <span
          className={`hijri-date date-segment date-align-${hijriAlignment}`}
          style={{ ...hijriStyle, textAlign: hijriAlignment }}
        >
          {hijriDate || "--"}
        </span>
      </div>
    </div>
  );
};

export default DateDisplay;
